module.exports = __webpack_public_path__ + "img/rule2.ce87de08.png";